/**
 * Valida si el usuario activo tiene sesión legítima de SuperAdmin en Softmatek.
 * Consulta al endpoint seguro /api/auth/verify para validar cookies HttpOnly y Bearer tokens.
 * Protege contra accesos no autorizados para no consumir créditos de Gemini/Veo.
 * @returns {Promise<{ isSuperAdmin: boolean, user: Object | null }>}
 */
export async function verifySuperAdminSession() {
  if (typeof window === 'undefined') {
    return { isSuperAdmin: false, user: null };
  }

  // 1. Entorno de desarrollo local
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return {
      isSuperAdmin: true,
      user: { role: 'SUPERADMIN', email: 'raulsilveira86@gmail.com', name: 'Raúl Silveira (Local)' }
    };
  }

  // 2. Soporte para Token de Softmatek / SuperAdmin pasado en URL (?token=... o ?auth=...)
  const urlParams = new URLSearchParams(window.location.search);
  const tokenFromUrl = urlParams.get('token') || urlParams.get('auth');
  if (tokenFromUrl) {
    localStorage.setItem('softmatek_admin_token', tokenFromUrl);
    // Limpiar URL para no dejar expuesto el token en la barra de direcciones
    window.history.replaceState({}, document.title, window.location.pathname);
  }

  // 3. Obtener token de LocalStorage
  const storedToken = localStorage.getItem('softmatek_admin_token') ||
                      localStorage.getItem('softmatek_token') ||
                      localStorage.getItem('mapau_admin_token');

  // 4. Verificación autoritativa contra el Backend (/api/auth/verify)
  try {
    const headers = {};
    if (storedToken) {
      headers['Authorization'] = `Bearer ${storedToken}`;
    }

    const res = await fetch('/api/auth/verify', {
      method: 'GET',
      headers,
      credentials: 'include'
    });

    if (res.ok) {
      const data = await res.json();
      if (data.success && data.isSuperAdmin) {
        return {
          isSuperAdmin: true,
          user: data.user || { role: 'SUPERADMIN', email: 'raulsilveira86@gmail.com' }
        };
      }
    } else {
      // Token inválido o expirado
      if (storedToken) {
        localStorage.removeItem('softmatek_admin_token');
      }
    }
  } catch (err) {
    console.warn('Verificación remota de sesión SuperAdmin falló:', err);
  }

  // 5. Cero accesos por defecto: Si no hay verificación positiva, bloquear
  return { isSuperAdmin: false, user: null };
}
